import * as React from 'react';
export const hyundaiSvg = React.forwardRef(function hyundaiSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#231F20',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 15.575c0-1.491 1.455-2.7 2.91-2.7h18.18c1.456 0 2.91 1.209 2.91 2.7v4.05h-1.454V16.25c0-1.118-.364-2.025-2.182-2.025H7.636c-1.818 0-2.181.907-2.181 2.025v3.375H4v-4.05Z',
      fill: '#fff',
    }),
  );
});
hyundaiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var hyundai = {
  category: 'brand',
  colorable: false,
  name: 'hyundai',
  svg: hyundaiSvg,
};
